export default __webpack_public_path__ + "static/media/2f001.9fe09a5f.png";